const PopSolutions = () => {
  return (
    <section className="revamp-skill-wrapper section-padding">
        <div className="container">
            <div className="row align-items-center">
                <div className="col-lg-6 col-xl-5">
                    <div className="section-title mb-30">
                        <span className="revamp-section-badge revamp-reveal">Our Expertise</span>
                        <h1 className="revamp-section-title revamp-reveal">Our Professional Solutions <br />
                            For IT Business</h1>
                    </div>

                    <div className="revamp-skill-bar revamp-reveal">
                        <h4>Creativity <span>90%</span></h4>
                        <div className="revamp-progress">
                            <div className="revamp-progress-bar" style={{width: "90%"}}></div>
                        </div>
                    </div>
                    <div className="revamp-skill-bar revamp-reveal">
                        <h4>Development <span>96%</span></h4>
                        <div className="revamp-progress">
                            <div className="revamp-progress-bar" style={{width: "96%"}}></div>
                        </div>
                    </div>
                    <div className="revamp-skill-bar revamp-reveal">
                        <h4>Production <span>88%</span></h4>
                        <div className="revamp-progress">
                            <div className="revamp-progress-bar" style={{width: "88%"}}></div>
                        </div>
                    </div>
                    <div className="revamp-skill-bar revamp-reveal">
                        <h4>UX/UI Strategy <span>70%</span></h4>
                        <div className="revamp-progress">
                            <div className="revamp-progress-bar" style={{width: "70%"}}></div>
                        </div>
                    </div>
                </div>

                <div className="col-lg-5 offset-lg-1 col-xl-5 offset-xl-2">
                    <div className="skill-banner mt-5 mt-lg-0 revamp-reveal">
                        <img src="assets/img/skill_freatured_img.webp" alt="Tech mentorship Abia" className="img-fluid" style={{borderRadius: '20px', boxShadow: '0 20px 60px rgba(0,0,0,0.3)'}} />
                    </div>
                </div>
            </div>
        </div>
    </section>
  );
};

export default PopSolutions;